import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHome: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home, house"><path fillRule="evenodd" clipRule="evenodd" d="M9.62536 2.22382C11.0067 1.0936 12.9933 1.09361 14.3746 2.22382L19.6246 6.51928C20.4952 7.23151 21 8.29687 21 9.42162V17.25C21 19.321 19.3211 21 17.25 21H6.75C4.67893 21 3 19.321 3 17.25V9.42162C3 8.29687 3.50485 7.23151 4.37536 6.51928L9.62536 2.22382Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHome;
